import { useMutation } from '@apollo/client';
import ConfirmDialog from '@website/components/utilities/ConfirmDialog';
import { RemoveUserAsGuestDocument } from '@website/types/graphqlOperations';
import { useState } from 'react';
import { Button } from 'react-bootstrap';

type Props = {
  spaceID: string;
};

/**
 *
 * RemoveUserAsGuest
 *
 * Remove the user as a guest from the space.
 *
 */
export default function RemoveUserAsGuest({ spaceID }: Props) {
  const [isConfirmDialogueVisible, setIsConfirmDialogueVisible] =
    useState(false);

  const [removeGuestAsUser, { loading }] = useMutation(
    RemoveUserAsGuestDocument,
  );

  const onRemoveGuest = async () => {
    try {
      await removeGuestAsUser({
        variables: {
          spaceID,
        },
      });
    } catch (e) {
      alert('Something went wrong!');
    }
  };

  return (
    <>
      <ConfirmDialog
        setVisible={(visible) => setIsConfirmDialogueVisible(visible)}
        title="Remove Guest"
        body={`Are you sure you want to remove this person?`}
        visible={isConfirmDialogueVisible}
        onCancelFn={() => setIsConfirmDialogueVisible(false)}
        onConfirmFn={() => onRemoveGuest()}
      />
      <Button
        variant="muted"
        onClick={() => setIsConfirmDialogueVisible(true)}
        size="sm"
        className="me-1 mb-1"
      >
        {loading ? 'Removing' : 'Remove'}
      </Button>
    </>
  );
}
